import React from 'react';
import { Modal } from 'react-bootstrap';
import './ImageModal.scss';
import { RiCloseCircleLine } from 'react-icons/ri';

const ImageModal = ({ show, handleClose, imageUrl }) => {
  return (
    <Modal
      className='image-modal'
      show={show}
      onHide={handleClose}
      centered
    >
      <button
        className='close'
        onClick={handleClose}
      >
        <RiCloseCircleLine />
      </button>
      <Modal.Body>
        <img className='image-modal__image' alt='' src={imageUrl} />
      </Modal.Body>
    </Modal>
  );
};

export default ImageModal;
